import { DropResult, DragStart, DragUpdate } from 'react-beautiful-dnd';
import { createContext } from 'react';

type DroppableEvents = {
  onDragStart?: (start: DragStart) => void;
  onDragUpdate?: (update: DragUpdate) => void;
  onDragEnd: (result: DropResult) => void;
};

export const getMMdndEvents = () => {
  const droppables: Map<string, DroppableEvents> = new Map();

  const onDragStart = (start: DragStart) => {
    const droppable = droppables.get(start.source.droppableId);

    if (droppable && droppable.onDragStart) {
      droppable.onDragStart(start);
    }
  };

  const onDragUpdate = (update: DragUpdate) => {
    const droppable = droppables.get(update.source.droppableId);

    if (droppable && droppable.onDragUpdate) {
      droppable.onDragUpdate(update);
    }
  };

  const onDragEnd = (result: DropResult) => {
    const { source, destination } = result;

    if (!destination || source.index === destination.index) return;

    const droppable = droppables.get(source.droppableId);

    if (droppable && droppable.onDragEnd) {
      droppable.onDragEnd(result);
    } else {
      throw new Error(
        `Cannot find onDragEnd handler for droppable ${source.droppableId}`,
      );
    }
  };

  const subscribe = (droppableId: string, droppableEvents: DroppableEvents) => {
    if (droppables.has(droppableId)) {
      throw new Error('Found duplicate droppableIds');
    }

    droppables.set(droppableId, droppableEvents);

    return () => {
      droppables.delete(droppableId);
    };
  };

  return { onDragStart, onDragUpdate, onDragEnd, subscribe };
};

export const MMdndContext = createContext(
  {} as ReturnType<typeof getMMdndEvents>,
);
